/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ correct: NonNullable<unknown>, total: NonNullable<unknown> }} Game_Correct_TodayInputs */

const bn_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} আজ সঠিক`)
};

const de_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} heute korrekt`)
};

const el_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} διορθώστε σήμερα`)
};

const en_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correct today`)
};

const es_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correcto hoy`)
};

const fr_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correct aujourd’hui`)
};

const hi_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} आज सही है`)
};

const hu_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} helyes ma`)
};

const id_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} benar hari ini`)
};

const it_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} corretto oggi`)
};

const ja_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`今日は${i?.correct}/${i?.total}が正解です`)
};

const ko_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} 오늘 정확함`)
};

const nl_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correct vandaag`)
};

const pl_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} poprawne dzisiaj`)
};

const pt_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} correto hoje`)
};

const ru_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} сегодня правильно`)
};

const sv_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} korrekt idag`)
};

const tr_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} bugün doğru`)
};

const uk_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} виправити сьогодні`)
};

const vi_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} đúng hôm nay`)
};

const zh_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} 今天正确`)
};

const zh_hant_game_correct_today = /** @type {(inputs: Game_Correct_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.correct}/${i?.total} 今天正確`)
};

/**
* | output |
* | --- |
* | "{correct}/{total} correct today" |
*
* @param {Game_Correct_TodayInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_correct_today = /** @type {((inputs: Game_Correct_TodayInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Correct_TodayInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_correct_today(inputs)
	if (locale === "de") return de_game_correct_today(inputs)
	if (locale === "el") return el_game_correct_today(inputs)
	if (locale === "en") return en_game_correct_today(inputs)
	if (locale === "es") return es_game_correct_today(inputs)
	if (locale === "fr") return fr_game_correct_today(inputs)
	if (locale === "hi") return hi_game_correct_today(inputs)
	if (locale === "hu") return hu_game_correct_today(inputs)
	if (locale === "id") return id_game_correct_today(inputs)
	if (locale === "it") return it_game_correct_today(inputs)
	if (locale === "ja") return ja_game_correct_today(inputs)
	if (locale === "ko") return ko_game_correct_today(inputs)
	if (locale === "nl") return nl_game_correct_today(inputs)
	if (locale === "pl") return pl_game_correct_today(inputs)
	if (locale === "pt") return pt_game_correct_today(inputs)
	if (locale === "ru") return ru_game_correct_today(inputs)
	if (locale === "sv") return sv_game_correct_today(inputs)
	if (locale === "tr") return tr_game_correct_today(inputs)
	if (locale === "uk") return uk_game_correct_today(inputs)
	if (locale === "vi") return vi_game_correct_today(inputs)
	if (locale === "zh") return zh_game_correct_today(inputs)
	return zh_hant_game_correct_today(inputs)
});